'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const ForecastChart = dynamic(() => import('@/app/reporting/components/ForecastBarChart'), { ssr: false });

const forecastRows = [
  { id: 'fc-001', metric: 'Service Revenue', current: '$58,740', forecast30: '$1.72M', vsLastMonth: '+6.2%', confidence: 87 },
  { id: 'fc-002', metric: 'Install Revenue', forecast30: '$312,000', current: '$287,400', vsLastMonth: '+8.5%', confidence: 82 },
  { id: 'fc-003', metric: 'Membership Revenue', forecast30: '$64,812', current: '$5,958/day', vsLastMonth: '+3.8%', confidence: 94 },
  { id: 'fc-004', metric: 'AR Collections', forecast30: '$284,000', current: '$41,930', vsLastMonth: '+11.2%', confidence: 76 },
];

export default function ForecastPanel() {
  return (
    <div className="bg-card rounded-lg card-shadow border border-border">
      <div className="px-5 py-4 border-b border-border flex items-center justify-between">
        <div>
          <h3 className="text-sm font-semibold text-foreground">30-Day Rolling Forecast</h3>
          <p className="text-xs text-muted-foreground mt-0.5">AI-generated · Weather-adjusted · July 2026</p>
        </div>
        <div className="bg-warning/10 border border-warning/20 rounded-md px-2 py-1">
          <span className="text-xs font-medium text-warning">+34% heat surge applied</span>
        </div>
      </div>
      <div className="px-5 py-4">
        <ForecastChart />
        <div className="mt-4 space-y-2">
          {forecastRows?.map((row) => (
            <div key={row?.id} className="flex items-center justify-between gap-4 py-1.5 border-b border-border/40 last:border-0 text-xs">
              <span className="text-foreground font-medium">{row?.metric}</span>
              <div className="flex items-center gap-4">
                <span className="text-muted-foreground">{row?.current} today</span>
                <span className="font-semibold font-tabular text-foreground">{row?.forecast30}</span>
                <span className="text-success font-semibold">{row?.vsLastMonth}</span>
                <div className="flex items-center gap-1">
                  <div className="w-12 bg-muted rounded-full h-1.5 overflow-hidden">
                    <div className="h-1.5 rounded-full bg-secondary" style={{ width: `${row?.confidence}%` }} />
                  </div>
                  <span className="text-muted-foreground font-tabular">{row?.confidence}%</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}